import "./btn.css"

import classNames from "classnames"
import React, { forwardRef } from "react"

import { BaseButton, BaseButtonElementProps } from "./BaseButton"

export type IconButtonProps = Omit<BaseButtonElementProps, "label"> & {
  /** Accessible label. Required for icon-only buttons to provide context about the button's purpose. */
  "aria-label": string
  /** The icon to display in the button. Set via story args for non-primitive values. */
  icon: React.ReactNode
}

/**
 * An icon-only button component that renders as a button element.
 * Requires an icon and aria-label for accessibility.
 *
 * @component
 * @see {@link https://planningcenter.github.io/tapestry/?path=/docs/components-button-icon-button--docs | Storybook Documentation}
 */
export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ className, icon, ...restProps }: IconButtonProps, ref) => {
    const iconOnlyClassName = classNames("tds-btn--icononly", className)

    return (
      <BaseButton
        {...restProps}
        label={icon}
        className={iconOnlyClassName}
        ref={ref}
      />
    )
  }
)

IconButton.displayName = "IconButton"
